import { Component, inject, OnInit } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { CurrentUserService, DbPerson } from "../../shared/CurrentUser.service";
import { QuickLinksService } from "../../shared/services/quick-links.service";
import { IQuickLinks } from "../../shared/quicklinks/IQuickLinks";

@Component({
  selector: 'quicklink-redirect',
  templateUrl: 'quicklink-redirect.component.html',
  standalone: true,
  providers: [CurrentUserService, QuickLinksService]
})
export class QuicklinkRedirectComponent implements OnInit {
  private userService = inject(CurrentUserService);
  private quicklinksService = inject(QuickLinksService);
  private router = inject(Router);

  ngOnInit() {
    this.GetQuickLink().subscribe((quickLink) => {
      this.router.navigateByUrl(quickLink.redirectTo, { replaceUrl: true, state: quickLink.navigationExtraState } as NavigationExtras)
    });
  }

  private GetQuickLink(): Observable<IQuickLinks> {
    return this.userService.GetApiUser().pipe(map((user) => {
      const quicklinkgroups = this.quicklinksService.getQuickLinkGroups(user as DbPerson);
      const quicklinks = [];
      quicklinkgroups.forEach((q) => q.quicklinks.forEach((quicklink) => quicklinks.push(quicklink)));
      const quicklink = quicklinks.find((link) => "/" + link.route == this.router.url);
      return quicklink ? quicklink : { route: "home", redirectTo: "home" };
    }));
  }
}
